import LocalStorage from "./localStorage";
import Cookie from "./cookie";

const getStorage = () => {
  if (LocalStorage.isLocalStorageSupported()) {
    return LocalStorage;
  }

  return Cookie;
};

export default {
  setItem (key, item) {
    getStorage().setItem(key, item);
  },

  getItem (key) {
    return getStorage().getItem(key) || null;
  },

  removeItem (key) {
    getStorage().removeItem(key);
  },

  clear () {
    getStorage().clear();
  }
};
